import { useState } from "react";
import { executePurchase } from "../../../../../api/listings";
import {
  setCurrentSwaps,
  setOwnedListings,
} from "../../../../../redux/pages/trainingPlanSlice";
import { useDispatch, useSelector } from "react-redux";
import useUser from "../../../../../hooks/user/useUser";
import { useModalContext } from "../../../../global/modals/ModalProvider";
import { RootState } from "../../../../../redux/store";
import { ModalActionSubmit } from "../../../../global/modals/ModalActionSubmit";
import { useListingModalSwapLimitReachedContext } from "./ListingModalSwapLimitReachedProvider";
import { useSnackbarContext } from "../../../../global/snackbar/SnackbarProvider";
import { ErrorSnackbar } from "../../../../global/snackbar";

export const ListingModalSwapSubmitBtn = () => {
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const { user } = useUser();
  const { closeModal } = useModalContext();
  const trainingPlanRedux = useSelector(
    (state: RootState) => state.trainingPlan,
  );
  const { state } = useListingModalSwapLimitReachedContext();

  const currentBorrowedListings = trainingPlanRedux.borrowedListings;
  const currentBorrowedListingIsAlreadyOwned = !!currentBorrowedListings.find(
    (item) => item.listingId === trainingPlanRedux.listingData.id,
  );
  const { setSnackbar } = useSnackbarContext();

  const handleReturnListing = () => {
    setIsLoading(true);
    executePurchase(
      trainingPlanRedux.listingData,
      user,
      state.listingToReturn.id,
    )
      .then((data) => {
        dispatch(setCurrentSwaps(data));
        closeModal();
        dispatch(
          setOwnedListings([
            ...trainingPlanRedux.ownedListings,
            trainingPlanRedux.listingData,
          ]),
        );
      })
      .catch((e) => {
        const error = e as Error;
        setSnackbar(<ErrorSnackbar message={error.message} />);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <ModalActionSubmit
      onClick={handleReturnListing}
      disabled={
        !state.listingToReturn ||
        isLoading ||
        trainingPlanRedux.swaps.available === 0 ||
        currentBorrowedListingIsAlreadyOwned
      }
    >
      Confirm
    </ModalActionSubmit>
  );
};
